const config = {
  url: process.env.API_URL,
  client_url: process.env.CLIENT_URL,
  stripe_api_key: process.env.STRIPE_API_KEY,
  nav: [
    { name: "Dashboard", href: "/", current: false },
    { name: "Workflows", href: "/workflows", current: false},
    { name: "Tunnels", href: "/tunnels", current: false},
  ]
};

export default config;
